<div class="label-popover-container position-relative"
     [matTooltip]="'task_label.trigger_tooltip' | translate"
     [matTooltipDisabled]="selectedItems.length > 0">
    <!-- Bouton pour ouvrir le popover -->
    <button class="btn d-flex align-items-center" 
            [disabled]="selectedItems.length === 0"
            [ngClass]="context === 'backlogList' ? 'py-1 btn-primary' : context === 'taskDetails' ? 'btn-action' : 'btn-primary'"
            (click)="togglePopover()">
      <div class="action-item-icon">
          <i class="fa-regular fa-bookmark"></i>
      </div>
      <div class="action-item-content px-2">
        <span class="action-item-title">
            @if(context === 'taskDetails' && selectedItems[0].labels.length > 0) {
                {{'task_label.task_details.trigger' | translate}}
            }@else {
                {{'task_label.trigger' | translate}}
            }
        </span>
      </div>
    </button>
  
    <!-- Popover -->
    @if (isPopoverOpen) {
        <div class="popover-backdrop" (click)="togglePopover()"></div>
        <task-label-popover  [context]="'backlog'"
                            [selectedLabels]="labels"
                            (labelsChange)="onLabelSelectionChanged($event)"
                            (apply)="onApply($event)"></task-label-popover>
    }
</div>